import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from '../../config'

const API_URL = `${config.baseUrl}`;

// Async thunk for getting opponent content
export const getOpponentContent = createAsyncThunk(
  "opponent/content",
  async () => {
    try {
      const ACCESS_TOKEN = localStorage.getItem("token");

      const response = await axios.get(`${API_URL}/list-opponent`, {
        headers: {
          Authorization: `Bearer ${ACCESS_TOKEN}`,
        },
      });
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

// Async thunk for deleting a opponent
export const deleteOurOpponent = createAsyncThunk(
  "opponent/delete",
  async (id = 1) => {
    try {
      await axios.delete(`${API_URL}/delete-opponent/${id}`);

      return id;
    } catch (error) {
      throw error;
    }
  }
);

// Async thunk for updating a opponent name
export const updateOpponentName = createAsyncThunk(
  "opponent/update",
  async ({ id, newName,newShortDescription,newFee,newDescription ,newMetaTitle,newMetaDescription }) => {
    try {
      const ACCESS_TOKEN = localStorage.getItem("token");
      const response = await axios.put(
        `${API_URL}/update-opponent/${id}`, 
        { opponent_name: newName,opponent_fee:newFee,short_description:newShortDescription,description:newDescription,meta_title:newMetaTitle,meta_description:newMetaDescription },
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

// Async thunk for adding a new opponent
export const addNewOpponent = createAsyncThunk(
  "opponent/addNew",
  async (newOpponentData) => {
    try {
      const ACCESS_TOKEN = localStorage.getItem("token");

      const response = await axios.post(
        `${API_URL}/add-opponent`,
        newOpponentData,
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN}`,
          },
        }
      );

      return response.data.data; // Return the newly added opponent data
    } catch (error) {
      throw error;
    }
  }
);

// Define the opponent slice
export const opponentSlice = createSlice({
  name: "opponent",
  initialState: {
    isLoading: false,
    opponents: [],
    opponentId: null, 
    opponentName: "",
    opponentFee:"",
    opponentStatus:"",
    error: null,
  },
  reducers: {
    // Define your reducers here if needed
    setOpponentData: (state, action) => {
      state.opponentId = action.payload.id;
      state.opponentStatus = action.payload.status;
      state.opponentName = action.payload.opponent_name;
      state.opponentFee = action.payload.opponent_fee;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOpponentContent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOpponentContent.fulfilled, (state, action) => {
        state.opponents = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getOpponentContent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(deleteOurOpponent.fulfilled, (state, action) => {
        const deletedOpponentId = action.payload;
        state.opponents = state.opponents.filter(
          (opponent) => opponent.id !== deletedOpponentId
        );
        state.isLoading = false;
        state.error = null;
      })
      .addCase(deleteOurOpponent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateOpponentName.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateOpponentName.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateOpponentName.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
        console.error("Error updating Opponent name:", action.error);
      })
      .addCase(addNewOpponent.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addNewOpponent.fulfilled, (state, action) => {
        state.opponents.push(action.payload); // Add the new data to the end of the array
        state.opponents.reverse(); // Reverse the order of the array
        state.isLoading = false;
        state.error = null;
      })
      
      .addCase(addNewOpponent.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message
          ? action.error.message
          : "Failed to add a new Opponent";
      });
  },
});

export const { deleteLead, setOpponentData } = opponentSlice.actions;

export default opponentSlice.reducer;